import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import Modal from "react-modal";

const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

export default function EditCategory({
    editCategoryInfo,
    setEdit,
    edit
}) {
    const [categoryInfo, setCategoryInfo] = useState({});
    const [hiddenUpdateInfo, setHiddenUpdateInfo] = useState({});
    const [topicInfo, setTopicInfo] = useState({});

      //get all kitab 
      useEffect(()  => {     
        async function fetchData() {   
            if(editCategoryInfo.topic === "Masala"){
                const allData = await axios.get(`https://ahlehaqserver.herokuapp.com/api/category/Masala`)
                setHiddenUpdateInfo(allData.data.response.find(data => data.category === editCategoryInfo.category));

                const m = await axios.get(`https://ahlehaqserver.herokuapp.com/api/masala`)
                setTopicInfo(m.data.response.find(data => data.category === editCategoryInfo.category));
            }else if(editCategoryInfo.topic === "Boyan"){
                const allData = await axios.get(`https://ahlehaqserver.herokuapp.com/api/category/Boyan`)
                setHiddenUpdateInfo(allData.data.response.find(data => data.category === editCategoryInfo.category));

                const boyan = await axios.get(`https://ahlehaqserver.herokuapp.com/api/boyan`)
                setTopicInfo(boyan.data.response.find(data => data.category === editCategoryInfo.category));
            }else{
                const allData = await axios.get(`https://ahlehaqserver.herokuapp.com/api/category/Doa`)
                setHiddenUpdateInfo(allData.data.response.find(data => data.category === editCategoryInfo.category));

                const doa = await axios.get(`https://ahlehaqserver.herokuapp.com/api/doa`)
                setTopicInfo(doa.data.response.find(data => data.category === editCategoryInfo.category));
            }
        }
        fetchData(); 
        setCategoryInfo(editCategoryInfo);
      },[editCategoryInfo])
     
     
    const CategoryUpdate = async (e) => {
        e.preventDefault();

        try {
          //update kitab name info
           const insert = await axios.put(`https://ahlehaqserver.herokuapp.com/api/category/${editCategoryInfo._id}`, categoryInfo);
        
           if(insert.data.code === 200){
              setEdit(false);
              toast.success(" Category edited successfully!");
           }

        
           //update information
            const ucinfo = {
              category:  categoryInfo.category,
            }

            //update category
           const categoryInserted = await axios.put(
            `https://ahlehaqserver.herokuapp.com/api/category/${hiddenUpdateInfo._id}`,
            ucinfo
          );

          if(editCategoryInfo.topic === "Masala"){
          const a = await axios.put(
                `https://ahlehaqserver.herokuapp.com/api/masala/${topicInfo._id}`,
                ucinfo
              );
              if(a.data.code === 200){
                  toast("update masala")
              }
          }else if(editCategoryInfo.topic === "Boyan"){
            await axios.put(
                `https://ahlehaqserver.herokuapp.com/api/boyan/${topicInfo._id}`,
                ucinfo
              );
          }else{
            await axios.put(
                `https://ahlehaqserver.herokuapp.com/api/doa/${topicInfo._id}`,
                ucinfo
              );
          }
          //if request success, will show success notification
          if (categoryInserted.data.code === 200) {
            setHiddenUpdateInfo({});
            
          }
        }catch{

        }
   }

    return (
        <Modal isOpen={edit} style={customStyles}>
        <div>
            <form onSubmit={CategoryUpdate}>
                <div className="row">
                
                     <div className={editCategoryInfo.topic === "Boyan"? "col-md-6" : "col-md-12"}>
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Write category name<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder="Write category name"
                              id="exampleInputPassword1"
                              name="category"
                              value={categoryInfo?.category || ""}
                              required
                              onChange={(e) =>
                                setCategoryInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value
                                }))
                              }
                            />
                          </div>
                       </div>

                       {
                           editCategoryInfo.topic === "Boyan" &&  
                           <div className="col-md-6">
                           <div className="form-group">
                               <label for="exampleInputEmail1" className="font-weight-bold">
                                 Select Language<span className="text-danger">*</span>
                               </label>
                               
                               <select
                                 className="form-control rounded"
                                 id="exampleInputEmail1"
                                 name="bangla"
                                 value={categoryInfo?.bangla || ""}
                                 required
                                 onChange={(e) =>
                                     setCategoryInfo((prev) => ({
                                     ...prev,
                                     [e.target.name]: e.target.value,
                                   }))
                                 }
                               >
                                 <option>
                                   Select Boyan Language
                                 </option>
                                     <option value="true">
                                       Bangla
                                     </option>
                                     <option value="false">
                                       Urdu
                                     </option>
                               </select>  
                           </div>
                         </div>
                       }


                       <div className="col-md-12">
                            <div className=" d-flex">
                                    <button
                                        type="submit"
                                        className="btn btn-success rounded px-4 ml-auto"
                                    >
                                        Done
                                    </button>

                                    <button
                                        className="btn btn-danger ml-2"
                                        onClick={() => setEdit(false)}
                                    >
                                        Close
                                    </button>
                                </div>
                       </div>
                      
                </div>
            </form>
        </div>
    </Modal>
    )
}
